<div class="footer">
    <div class="sections row">
        <div class="section">
            <p> Copyright :<br>
                 © 2022 National Robotics Weekend, All Rights Reserved.</p>
            <div class="contact">
                <p>
                    <i class="fa-solid fa-location-dot"></i> 676 INSAT Centre Urbain Nord BP، Tunis Cedex 108
                </p>
              <p></p>
              <i class="fa-solid fa-phone"></i> 99 223 547
               <p>
                <i class="fa-solid fa-envelope"></i>  nrwcongress@gmail.com
               </p>
            </div>
        </div>
        <div class="section">
            <img  src="../../../assets/logos/logo.png" >
            <p >
                An opportunity for robotics enthusiasts to broaden their knowledge ,forge new useful relationship
                and showcase their talents in this dynamic field.
            </p>
        </div>
        
        <div class="section">
            <p>
                Follow us on social Media :
            </p>
            <div class="row social">
            <a href="https://www.facebook.com/NationalRoboticsWeekend/"><img src="../../../assets/icons/facebook.png" ></a>
            <a href="https://instagram.com/nationalroboticsweekend?utm_medium=copy_link"> <img src="../../../assets/icons/instagram (1).png" ></a>  
            <a href=" https://www.linkedin.com/company/national-robotics-weekend"><img src="../../../assets/icons/linkedin-logo.png" ></a> 
            </div>
        </div>
    </div>
    <img class="banner" src ="../../../assets/logos/nrw_congress.jpg">
</div>
